module.exports = function() {
  return new Worker(__webpack_public_path__ + "8eef0acc563551db5308.worker.js");
};